import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import {
  selectVehicleOwnerContactPersonData,
  selectIsContactPersonOther,
  selectUIData,
} from "../vehicleOwner.selectors";
import { setContactPersonType, setUIObjectField } from "../vehicleOwner.slice";

import { ComponentId } from "./enums";

export const main = (
  wasVehicleInMotion: boolean
): FormSchema<SimpleFormSchemaComponents> => {
  const items = wasVehicleInMotion
    ? [
        {
          label: "Zgłaszający",
          value: "applicant",
        },
        {
          label: "Kierowca",
          value: "driver",
        },
        {
          label: "Właściciel pojazdu",
          value: "owner",
        },
        {
          label: "Inna osoba",
          value: "otherPerson",
        },
      ]
    : [
        {
          label: "Zgłaszający",
          value: "applicant",
        },
        {
          label: "Właściciel pojazdu",
          value: "owner",
        },
        {
          label: "Inna osoba",
          value: "otherPerson",
        },
      ];

  return {
    formId: FormId.VEHICLE_OWNER_CONTACT_PERSON_DATA,
    id: [FormId.VEHICLE_OWNER_CONTACT_PERSON_DATA, "main"].join("-"),
    selector: selectVehicleOwnerContactPersonData,
    content: [
      {
        title: "Osoba kontaktowa",
        sections: [
          {
            id: "vehicle-owner-contact-person-data-1",
            wrapper: { xs: 12 },
            components: [
              {
                type: FormElement.RADIO,
                id: ComponentId.PERSON_TYPE,
                onChange: setContactPersonType,
                label:
                  "Kto jest osobą kontaktową do czynności związanych z likwidacją szkody?",
                required: true,
                items,
              },
            ],
          },
        ],
      },
    ],
  };
};

export const formDetails: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_CONTACT_PERSON_DATA,
  id: [FormId.VEHICLE_OWNER_CONTACT_PERSON_DATA, "details"].join("-"),
  selector: selectVehicleOwnerContactPersonData,
  isVisible: selectIsContactPersonOther,
  content: [
    {
      sections: [
        {
          id: "vehicle-owner-contact-person-data-2",
          title: "Dane innej osoby kontaktowej",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.NAME,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.SURNAME,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-contact-person-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.COMPANY_NAME,
              label: "Nazwa firmy",
            },
          ],
        },
        {
          id: "vehicle-owner-contact-person-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("contactPersonphone"),
              id: ComponentId.PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.EMAIL,
              label: "Email",
              tooltip:
                "Jeśli nie poda Pan/Pani adresu email, korespondencja będzie wysyłana pocztą, a czas likwidacji może się wydłużyć. Nie wykorzystamy maila do wysyłania pism innych niż związane ze szkodą.",
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
